import { observer } from 'mobx-react';
import * as React from 'react';
import NereusSelect from '../../NereusSelect/NereusSelect';
import UserDeposits from '../UserDeposits/UserDeposits';
import UserWithdrawals from '../UserWithdrawals/UserWithdrawals';
import MenuItem from '@mui/material/MenuItem';
import './UserActivity.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { marketsStore } from '../../../stores/MarketsStore';

const UserActivityTabValue = {
    DEPOSITS: 'deposits',
    WITHDRAWALS: 'withdrawals'
}

const UserActivity = observer(() => {

    const currentMarket = marketsStore.currentMarket
    const navigate = useNavigate();

    const { tab: routeTab, filter: routeFilter } = useParams();
    const currentFilter = routeFilter || UserActivityTabValue.DEPOSITS;

    const handleChange = (event: any) => {

        navigate(`/markets/${currentMarket?.marketId}/${routeTab}/${event.target.value}`);
    };

    return (
        <div className="UserActivity">
            <div className="flex items-center mb-4 ml-4">
                <div className="UserActivity__filter-by mr-4">Filter By:</div>

                <NereusSelect value={currentFilter}
                              onChange={handleChange}
                              style={{
                                  height: 32,
                                  width: 170,
                                  color: 'white'
                              }}
                >
                    <MenuItem value={UserActivityTabValue.DEPOSITS}>Deposits</MenuItem>
                    <MenuItem value={UserActivityTabValue.WITHDRAWALS}>Withdrawals</MenuItem>
                </NereusSelect>
            </div>
            {currentFilter === UserActivityTabValue.DEPOSITS && <UserDeposits/>}
            {currentFilter === UserActivityTabValue.WITHDRAWALS && <UserWithdrawals/>}
        </div>
    );
});

export default UserActivity;
